<app-portal-collapsible
    icon="tablet"
    [title]="tablet().title"
    [subtitle]="'Seriennr: ' + tablet().serialNumber"
    [alert]="!isComplete() ? 'Seriennummer fehlt' : undefined"
>
    @if (!isComplete()) {
        <i
            collapsibleHeading
            class="c:red"
            ctrlIcon="warning"
            aria-label="Nicht vollständig"
        ></i>
    }
    <dl class="grid-container vertical-gutter-lg">
        <app-portal-widget-details
            class="g-12"
            heading="Kaufpreis"
            [detail]="tablet().price.replace(',', '.') | currency: 'EUR' : 'symbol' : '3.2-2' : 'de'"
        ></app-portal-widget-details>

        @if (isComplete()) {
            <app-portal-widget-details
                class="g-12"
                heading="Seriennummer"
                [detail]="tablet().serialNumber"
            ></app-portal-widget-details>
        } @else {
            <form
                class="g-12"
                [formGroup]="formGroup"
                (ngSubmit)="handleSubmit()"
            >
                <div class="grid-container">
                    <div class="form-control g-12">
                        <label
                            >Seriennummer:
                            <input
                                type="text"
                                formControlName="serialNumber"
                            />
                        </label>

                        @if (formGroup.touched && formGroup.invalid) {
                            <span
                                class="form-error-note"
                                aria-live="polite"
                                >Bitte gib die Seriennummer des Geräts an.</span
                            >
                        }
                    </div>

                    <button
                        class="g-12 sm:g-6 sm:g-offset-6 -blue"
                        type="submit"
                        [disabled]="submitting || formGroup.invalid"
                    >
                        <i ctrlIcon="save"></i>Speichern
                    </button>
                </div>
            </form>
        }
    </dl></app-portal-collapsible
>
